import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-filter-option',
  imports: [],
  template: `
    <button
      type="button"
      class="filter-option"
      [class.active]="active()"
      (click)="handleClick()">
      {{ label() }}
    </button>
  `,
  styleUrl: './filter-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterOptionComponent {
  readonly label = input.required<string>();
  readonly value = input.required<string>();
  readonly active = input(false);

  readonly selected = output<string>();

  handleClick(): void {
    this.selected.emit(this.value());
  }
}
